var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgColoredArchive = function SvgColoredArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13 6.646v6.02c0 1.334-.333 2-2 2H5c-1.667 0-2-.666-2-2v-6.02c.107.014.22.02.333.02h9.334c.113 0 .226-.006.333-.02Z",
    fill: "#637589"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 3.333v1.333c0 1.22-.553 1.88-1.666 1.98-.107.014-.22.02-.334.02H3.333c-.113 0-.227-.006-.333-.02-1.114-.1-1.667-.76-1.667-1.98V3.333c0-1.333.667-2 2-2h9.333c1.334 0 2 .667 2 2ZM9.214 9.833H6.787a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h2.427c.273 0 .5.227.5.5s-.227.5-.5.5Z",
    fill: "#637589"
  })));
};
export default SvgColoredArchive;